export default class LocalFileApi {
    constructor() {}

    static async saveFile( fileContents ) {
        const options = {
            types: [
                {   description: 'Text Files',
                    accept: { 'text/plain': ['.txt'], 'text/plain': ['.gcode'] },
                },
            ],
        };
        const fileHandle = await window.showSaveFilePicker(options);
        const writable = await fileHandle.createWritable();        
        await writable.write(fileContents);     // Write the contents of the file to the stream.
        await writable.close();                 // Close the file and write the contents to disk.
    }

    static async loadFile( successCallback ) {
        let fileHandle;
        [fileHandle] = await window.showOpenFilePicker();
        const file = await fileHandle.getFile();
        let contents = await file.text();
        successCallback( contents );        
    }

    // Sends the sketch SVG to vpypeserver to be processed and coinverted to gcode for plotting
    // Requires axios js
    static async saveSVG(){
        let svg = document.querySelector("svg").outerHTML;
        axios.post('http://localhost:3000/api/svg2gcode', {
          filename: 'myfile', 
          svg: svg
        })
        .then(function (response) {
          console.log("Response: ", response);
        })
        .catch(function (error) {
          console.log(error);
        });
      }
}